import React, { useContext } from "react";
import { TranslatorContext } from "../context/Translator";

export default function FileUploadComponent({ icon, text, name, onChange }) {
    const { t } = useContext(TranslatorContext)

    return (
        <>
            {text ?
                <div className={`mc-file-upload ${ text ? "button" : "icon" }`}>
                    <input type="file" id={name} name={name || "avatar" } onChange={onChange} />
                    <label htmlFor={name || "avatar"}>
                        <i className="material-icons">{ icon || t('cloud_upload') }</i>
                        <span>{ text || t('upload') }</span>
                    </label>
                </div>
            :
                <div className={`mc-file-upload ${ text ? "button" : "icon" }`}>
                    <input type="file" id={name} name={name || "avatar" } onChange={onChange} />
                    <label htmlFor={name || "avatar"} className="material-icons">{ icon || t('cloud_upload') }</label>
                </div>
            }
        </>
    )
}